import axios from 'axios';
import config from '../../config';

interface Country {
  id: string;
  code: string;
  name: string;
}

interface CountryResponse {
  success: boolean;
  data: {
    id: string;
    countryCode: string;
    countryName: string;
    faviconUrl: string | null;
    isActive: boolean;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
  }[];
}

// Create axios instance with base URL
const api = axios.create({
  baseURL: config.api.baseUrl,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getCountries = async (): Promise<Country[]> => {
  try {
    const response = await api.get<CountryResponse>('/api/web/country');
    return response.data.data.map((country: any) => ({
      id: country.id,
      code: country.countryCode,
      name: country.countryName
    }));
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
};
